export default "__VITE_ASSET__12e7487d__"